import { useEffect, useState } from "react";
import "./styles.css";
import { toast } from "react-toastify";
import { FaPlus } from "react-icons/fa";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import api from "../../../../services/axiosConfig";
import ModalNovaMensagem from "./ModalNovaMensagem/ModalNovaMensage";
import Swal from "sweetalert2";

function Mensagens() {
  const [listaMensagens, setListaMensagens] = useState([]);
  const [modalAberta, setModalAberta] = useState(false);
  const [mensagemSelecionada, setMensagemSelecionada] = useState(null);
  const [filtroTitulo, setFiltroTitulo] = useState("");
  const [filtroTipoConta, setFiltroTipoConta] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalMensagens, setTotalMensagens] = useState(0);
  const [sortBy, setSortBy] = useState("createdAt");
  const [order, setOrder] = useState("desc");

  async function fetchMensagens() {
    try {
      const params = {
        page,
        limit,
        sortBy,
        order,
        title: filtroTitulo || undefined,
        tipoConta: filtroTipoConta || undefined,
      };

      const response = await api.get("/mensagens/admin/listar-tudo", { params });
      setListaMensagens(response.data?.messages || []);
      setTotalPages(response.data?.pages || 1);
      setTotalMensagens(response.data?.total || 0);
    } catch (error) {
      console.error("Erro ao buscar mensagens:", error);
      toast.error("Não foi possível carregar as mensagens.");
    }
  }

  useEffect(() => {
    fetchMensagens();
  }, [page, sortBy, order, filtroTitulo, filtroTipoConta]);

  async function handleDeleteMessage(messageId) {
    
    const result = await Swal.fire({
        title: 'Tem certeza?',
        text: "Você não poderá reverter esta ação!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
        });

    if(result.isConfirmed) {
        if (result.isConfirmed) {
        try {
          await api.delete(`/mensagens/${messageId}/excluir`);
          
          toast.success("A mensagem foi removida com sucesso.")
          fetchMensagens();
        } catch (error) {
          console.error("Erro ao excluir mensagem:", error);
          toast.error("Erro ao excluir a mensagem.");
        }
      }
    }
  }
  
  const handleEdit = (mensagem) => {
    setMensagemSelecionada(mensagem);
    setModalAberta(true);
  };

  const handleCreate = () => {
    setMensagemSelecionada(null);
    setModalAberta(true);
  };
  
  const formatarData = (dataString) => {
    const data = new Date(dataString);
    return data.toLocaleString('pt-BR');
  }

  return (
    <div className="mensagens-container">
      <div className="mensagens-header">
        <h3>Gerenciamento de Mensagens</h3>
      </div>

      <Row className="mb-3 d-flex align-items-end">
        <Col md={4}>
          <FormGroup>
            <Label>Buscar por Título</Label>
            <Input
              type="search"
              value={filtroTitulo}
              placeholder="Digite o título da mensagem..."
              onChange={(e) => {
                setPage(1);
                setFiltroTitulo(e.target.value);
              }}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label>Tipo de Conta</Label>
            <Input
              type="select"
              value={filtroTipoConta}
              onChange={(e) => {
                setPage(1);
                setFiltroTipoConta(e.target.value);
              }}
            >
              <option value="">Todos</option>
              <option value="usuario">Cortador</option>
              <option value="influenciador">Influenciador</option>
              <option value="afiliado">Afiliado</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={5} >
            <div style={{ paddingBottom: '1rem' }}> 
                <Button color="primary" onClick={handleCreate}>
                <FaPlus className="me-2" /> Nova Mensagem
                </Button>
          </div>
        </Col>
      </Row>

       <div style={{ marginTop: 15, marginBottom: 10 }}>
         <span style={{ fontWeight: "bold", color: "#6d6d6d" }}>
           Total de mensagens: {totalMensagens}
         </span>
       </div>

      <Table striped responsive>
        <thead>
          <tr>
            <th style={{ cursor: "pointer" }} onClick={() => { setSortBy("title"); setOrder(order === "asc" ? "desc" : "asc"); }}>
              Título{" "}
              {sortBy === "title" && (order === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th style={{ cursor: "pointer" }} onClick={() => { setSortBy("tipoConta"); setOrder(order === "asc" ? "desc" : "asc"); }}>
              Tipo de Conta{" "}
              {sortBy === "tipoConta" && (order === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th style={{ cursor: "pointer" }} onClick={() => { setSortBy("clickCount"); setOrder(order === "asc" ? "desc" : "asc"); }}>
              Visualizações{" "}
              {sortBy === "clickCount" && (order === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th style={{ cursor: "pointer" }} onClick={() => { setSortBy("createdAt"); setOrder(order === "asc" ? "desc" : "asc"); }}>
              Data de Criação{" "}
              {sortBy === "createdAt" && (order === "asc" ? <IoIosArrowDown /> : <IoIosArrowUp />)}
            </th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {listaMensagens.map((msg) => (
            <tr key={msg._id}>
              <td>{msg.title}</td>
              <td style={{textTransform: 'capitalize'}}>{msg.tipoConta === "usuario" ? 'Cortador' : msg.tipoConta || "Geral (para todos)"}</td>
               <td>{msg.clickCount}</td>
              <td>{formatarData(msg.createdAt)}</td>
              <td>
                <Button color="success" size="sm" className="me-2" onClick={() => handleEdit(msg)}>
                  Editar
                </Button>
                <Button color="danger" size="sm" onClick={() => handleDeleteMessage(msg._id)}>
                  Excluir
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      
      {listaMensagens.length === 0 && <p className="text-center">Nenhuma mensagem encontrada.</p>}

      <Pagination style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
        <PaginationItem disabled={page === 1}>
          <PaginationLink previous onClick={() => setPage(page - 1)} />
        </PaginationItem>
        {[...Array(totalPages).keys()].map(i => (
          <PaginationItem active={page === i + 1} key={i}>
            <PaginationLink onClick={() => setPage(i + 1)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        <PaginationItem disabled={page >= totalPages}>
          <PaginationLink next onClick={() => setPage(page + 1)} />
        </PaginationItem>
      </Pagination>

      <ModalNovaMensagem
        isOpen={modalAberta}
        onClose={() => {
            setModalAberta(false);
            fetchMensagens(); 
        }}
        mensagemSelecionada={mensagemSelecionada}
      />

    </div>
  );
}

export default Mensagens;